/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 11L13 8M10 11L13 14M10 11H14.8C15.9201 11 16.4802 11 16.908 11.218C17.2843 11.4097 17.5903 11.7157 17.782 12.092C18 12.5198 18 13.0799 18 14.2V15.5V16.0001M9 8L6 11L9 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M10 11L13 8M10 11L13 14M10 11H14.8C15.9201 11 16.4802 11 16.908 11.218C17.2843 11.4097 17.5903 11.7157 17.782 12.092C18 12.5198 18 13.0799 18 14.2V15.5V16.0001M9 8L6 11L9 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM9.53033 8.53033C9.82322 8.23744 9.82322 7.76256 9.53033 7.46967C9.23744 7.17678 8.76256 7.17678 8.46967 7.46967L5.46967 10.4697C5.17678 10.7626 5.17678 11.2374 5.46967 11.5303L8.46967 14.5303C8.76256 14.8232 9.23744 14.8232 9.53033 14.5303C9.82322 14.2374 9.82322 13.7626 9.53033 13.4697L7.06066 11L9.53033 8.53033ZM13.5303 8.53033C13.8232 8.23744 13.8232 7.76256 13.5303 7.46967C13.2374 7.17678 12.7626 7.17678 12.4697 7.46967L9.46967 10.4697C9.17678 10.7626 9.17678 11.2374 9.46967 11.5303L12.4697 14.5303C12.7626 14.8232 13.2374 14.8232 13.5303 14.5303C13.8232 14.2374 13.8232 13.7626 13.5303 13.4697L11.8107 11.75H14.8C15.3724 11.75 15.7566 11.7506 16.0525 11.7748C16.3396 11.7982 16.4769 11.8401 16.5675 11.8862C16.8027 12.0061 16.9939 12.1973 17.1138 12.4325C17.1599 12.5231 17.2018 12.6604 17.2252 12.9475C17.2494 13.2434 17.25 13.6276 17.25 14.2V15.5V16.0001C17.25 16.4143 17.5858 16.7501 18 16.7501C18.4142 16.7501 18.75 16.4143 18.75 16.0001V15.5V14.2V14.1695C18.75 13.6354 18.75 13.1896 18.7203 12.8253C18.6892 12.4454 18.6221 12.0888 18.4503 11.7515C18.1866 11.2341 17.7659 10.8134 17.2485 10.5497C16.9112 10.3779 16.5546 10.3108 16.1747 10.2797C15.8104 10.25 15.3646 10.25 14.8304 10.25H14.8H11.8107L13.5303 8.53033Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M10 11L13 8M10 11L13 14M10 11H14.8C15.9201 11 16.4802 11 16.908 11.218C17.2843 11.4097 17.5903 11.7157 17.782 12.092C18 12.5198 18 13.0799 18 14.2V15.5V16.0001M9 8L6 11L9 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M10 11L13 8M10 11L13 14M10 11H14.8C15.9201 11 16.4802 11 16.908 11.218C17.2843 11.4097 17.5903 11.7157 17.782 12.092C18 12.5198 18 13.0799 18 14.2V15.5V16.0001M9 8L6 11L9 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.53033 7.46967C9.82322 7.76256 9.82322 8.23744 9.53033 8.53033L7.06066 11L9.53033 13.4697C9.82322 13.7626 9.82322 14.2374 9.53033 14.5303C9.23744 14.8232 8.76256 14.8232 8.46967 14.5303L5.46967 11.5303C5.17678 11.2374 5.17678 10.7626 5.46967 10.4697L8.46967 7.46967C8.76256 7.17678 9.23744 7.17678 9.53033 7.46967ZM13.5303 7.46967C13.8232 7.76256 13.8232 8.23744 13.5303 8.53033L11.8107 10.25H14.8L14.8304 10.25C15.3646 10.25 15.8104 10.25 16.1747 10.2797C16.5546 10.3108 16.9112 10.3779 17.2485 10.5497C17.7659 10.8134 18.1866 11.2341 18.4503 11.7515C18.6221 12.0888 18.6892 12.4454 18.7203 12.8253C18.75 13.1896 18.75 13.6354 18.75 14.1695V14.2V15.5V16.0001C18.75 16.4143 18.4142 16.7501 18 16.7501C17.5858 16.7501 17.25 16.4143 17.25 16.0001V15.5V14.2C17.25 13.6276 17.2494 13.2434 17.2252 12.9475C17.2018 12.6604 17.1599 12.5231 17.1138 12.4325C16.9939 12.1973 16.8027 12.0061 16.5675 11.8862C16.4769 11.8401 16.3396 11.7982 16.0525 11.7748C15.7566 11.7506 15.3724 11.75 14.8 11.75H11.8107L13.5303 13.4697C13.8232 13.7626 13.8232 14.2374 13.5303 14.5303C13.2374 14.8232 12.7626 14.8232 12.4697 14.5303L9.46967 11.5303C9.17678 11.2374 9.17678 10.7626 9.46967 10.4697L12.4697 7.46967C12.7626 7.17678 13.2374 7.17678 13.5303 7.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
